export { default } from './LayoutHead';
